module.exports = __webpack_public_path__ + "img/pen-edit.864fc1ea.svg";